import { createFailure, createRequest, createSuccess } from 'ducks/helpers';
import constants from './constants';

export const releaseNotesRequest = createRequest(constants.releaseNotes);
export const releaseNotesSuccess = createSuccess(constants.releaseNotes);
export const releaseNotesFailure = createFailure(constants.releaseNotes);
